import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';
import { StyledAccordion, Title } from './styled';

const Accordion = ({ title, children, color, open = false }) => {
  const [isOpen, setIsOpen] = useState(open);
  return (
    <StyledAccordion>
      <Title color={color} onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <FaCaretUp /> : <FaCaretDown />}
        <h3>{title}</h3>
      </Title>
      {isOpen && children}
    </StyledAccordion>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  open: PropTypes.bool
};

export default Accordion;
